import * as styles from "./ListItem.css";

import { useAtomValue } from "jotai";
import { ForesightManager } from "js.foresight";
import { Factory, UserRound } from "lucide-react";
import { useEffect, useRef } from "react";

import { Avatar } from "@frontend/components/atoms/Avatar";

import { isContactSelectedAtom } from "../../stores";
import type { Contact } from "../../types";

type ListItemProps = {
  contact: Contact;
  onSelect?: (contact: Contact) => void;
  isLast?: boolean;
};

export function ListItem({ contact, onSelect, isLast }: ListItemProps) {
  const isSelected = useAtomValue(isContactSelectedAtom(contact.id));

  // const photoUrl =
  //   contact.hasPhoto && contact.cardId
  //     ? `/media/cache/contact_avatar/${contact.cardId}`
  //     : undefined;

  const avatarUrl = contact.hasPhoto ? contact.avatarUrl || "" : undefined;

  const fallback = contact.isOrganization ? <Factory /> : <UserRound />;

  const ref = useRef<HTMLDivElement>(null);

  // useEffect(() => {
  //   const el = ref.current;

  //   if (!el) {
  //     return;
  //   }

  //   const { unregister } = ForesightManager.instance.register({
  //     element: el,
  //     name: contact.displayName,
  //     callback: () => {
  //       console.log(`Foresight: ${contact.displayName} is in view`);
  //     },
  //   });

  //   return unregister;
  // }, [contact.id]);

  return (
    <div
      ref={ref}
      className={styles.item({ selected: isSelected, isLast })}
      onClick={() => onSelect?.(contact)}
    >
      <Avatar
        className={styles.icon({
          type: contact.isOrganization ? "organization" : "person",
        })}
        url={avatarUrl}
        size="lg"
        fallback={fallback}
        // style={{ width: "2rem", height: "2rem" }} // taille initiale
      />

      <span className={styles.name}>{contact.displayName}</span>
    </div>
  );

  // contact.note
  //   ? span({ class: "list-item-note" }, ` (${contact.note})`)
  //   : null,
}
